import { DOCUMENT_SETSTATE } from "./GalleryActionType";

const apiConfig = window as any;

const initialState = {
    startv: false,
    indexV: 1,
    intIceImage:apiConfig.ICE_CARVING_IMAGE_COUNTER,
    intVegImage:apiConfig.VEG_CARVING_IMAGE_COUNTER
};

export function GalleryReducer(state = initialState, action: any) {
    switch (action.type) {
        case DOCUMENT_SETSTATE:
            return { ...state, [action.payload.key]: action.payload.value };
        default:
            return state;
    }
}
